import { AxiosRequestConfig } from 'axios';
import vm from '@/main';

/**
 * Modifies an Axios request to include the current app language in the headers.
 */
export const translationRequestMiddleware = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const app = vm();
  const language = app?.$store.state.language || 'en';

  // set rs-lang header before request is sent.
  config.headers!['rs-lang'] = language;

  return config;
};
